import ability from '@/libs/acl/ability'
import i18n from '@/libs/i18n'
import navMenuItems from '@/navigation/vertical'

const exploreChild = (array, arrayFinal) => {

    array.forEach(item => {
        if (item.children) {
            if (item.children.children) {
                if (item.children.children.children) {
                    return exploreChild(item.children.children.children, arrayFinal)
                }
                return exploreChild(item.children.children, arrayFinal)
            }
            return exploreChild(item.children, arrayFinal)
        }
        if (ability.can(item.action, item.resource)) {
            arrayFinal.push({
                title: i18n.global.t(item.title),
                route: { name: item.route },
                icon: item.icon,
                fontIcon: item.fontIcon,
                isBookmarked: false,
            })
        }
        return item
    })
}

export default {
    namespaced: true,
    state: {
        menuLinksAllowed: [],
    },
    getters: {},
    mutations: {
        UPDATE_MENU_LINKS_ALLOWED(state) {
            const menuLinks = []
            exploreChild(navMenuItems, menuLinks)
            state.menuLinksAllowed = menuLinks
        },
    },
    actions: {},
}
